/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Draft, LineItem } from 'admin/stores/redux/AdminDraft/interfaces';

interface AdminDraftState {
    initialized: boolean;
    draft: Draft | null;
    snapShot: Draft | null;
}

const initialState: AdminDraftState = {
    initialized: false,
    draft: null,
    snapShot: null,
};

export const adminDraftSlice = createSlice({
    name: 'adminDraft',
    initialState,
    reducers: {
        reset() {
            return initialState;
        },
        init(state: AdminDraftState, action: PayloadAction<Draft>) {
            state.initialized = true;
            state.draft = action.payload;
        },
        initSnapShot(state: AdminDraftState, action: PayloadAction<Draft>) {
            state.snapShot = action.payload;
        },
        replace(state: AdminDraftState, action: PayloadAction<Draft>) {
            state.draft = action.payload;
        },
        updateLineItems(
            state: AdminDraftState,
            action: PayloadAction<LineItem[]>
        ) {
            if (state.draft) {
                state.draft.lineItems = action.payload;
            }
        },
    },
});

export const { reset, init, initSnapShot, replace, updateLineItems } =
    adminDraftSlice.actions;

export default adminDraftSlice.reducer;
